import React from 'react';
import {useField} from 'formik';
import {FormControl, FormControlLabel, Switch, Typography} from '@mui/material';
import {AutoBooleanProps} from './AutoFieldNew';
import {AutoFieldDebug} from './AutoFieldDebug';
import {SaltusAny} from '../../utils/SaltusAny';

export function AutoBoolean({
  controlledValue,
  setControlledValue,
  handleFieldSubmit,
  onBlur,
  readOnly,
  disabled,
  field,
  ...props
}: AutoBooleanProps) {
  const [formikField, formikMeta, formikHelpers] = useField({
    name: field.id,
    validate: field.validation as any,
  });
  const isDisabled = disabled || field.disabled || readOnly;
  const onChange = (e: SaltusAny) => {
    if (isDisabled) {
      // do nothing
      return;
    }
    if (formikField.value === field.yesValue) {
      formikHelpers.setValue(field.noValue, true);
    } else {
      formikHelpers.setValue(field.yesValue, true);
    }
  };
  const {labelNotClickable} = field;

  return (
    <FormControl
      onClick={(e) => (field.labelNotClickable ? {} : onChange(e))}
      disabled={isDisabled}
      error={!!formikMeta.error}
      fullWidth
      size={field.size}
    >
      {/* {isDisabled ? 'disabled' : 'not disabled'} */}
      {/* {formikField.value === field.yesValue ? 'yes' : 'no'} */}
      <AutoFieldDebug>{field.id}</AutoFieldDebug>
      <FormControlLabel
        data-test={field.label}
        disabled={isDisabled}
        htmlFor={field.id}
        label={field.label}
        control={
          <Switch
            disabled={isDisabled}
            onClick={(e) => (field.labelNotClickable ? onChange(e) : {})}
            // onBlur={onBlur}
            checked={formikField.value === field.yesValue}
            type="checkbox"
            name={field.id}
          />
        }
      />
      {formikMeta.error ? (
        <Typography
          color="error"
          variant="body2"
          style={{fontSize: '0.7rem', marginTop: 4}}
        >
          {formikMeta.error}
        </Typography>
      ) : null}
    </FormControl>
  );
}
